/**
 * AutoAgentPage — standalone /autoagent route.
 *
 * Thin wrapper around AutoAgentPane (the proven AI agent UI). Reads
 * project + initial description from the URL and delegates to the pane.
 * Builder Mode embeds the same pane inside its split-pane workspace.
 */

import { useSearchParams } from 'react-router-dom'
import AutoAgentPane from './AutoAgentPane'

export default function AutoAgentPage() {
  const [searchParams] = useSearchParams()
  const project = searchParams.get('project') || 'Draft Application'
  const initialDescription = searchParams.get('description') || ''
  // 'build' (the agentic "AI Agent" entry) vs 'step' (deterministic pipeline).
  const initialMode = searchParams.get('mode') === 'build' ? 'build' : 'step'

  return (
    <AutoAgentPane
      project={project}
      initialDescription={initialDescription}
      initialMode={initialMode}
      showBackButton
    />
  )
}
